<template>
  <div class="item">
    <div class="top_title">
      <div class="left_side">
        <div class="order_text">
          <p>订单号: {{ orderItem.escOrderId }}</p>
          <span class="copy_icon" @click.stop="copyText(orderItem.escOrderId)">复制</span>
        </div>
      </div>
      <div class="right_tip">待核销</div>
    </div>
    <div class="item_box">
      <div class="item_good single" v-if="orderItem.delevery[0].prd.length == 1">
        <div class="left_img">
          <img width="70px" height="70px" :src="orderItem.delevery[0].prd[0].productPic.split('|*|')[0].replace('http:', 'https:')" />
        </div>
        <div class="right_side">
          <div class="top">
            <h2>{{ orderItem.delevery[0].prd[0].productName }}</h2>
            <p class="price">¥{{ orderItem.delevery[0].prd[0].salPrice }}</p>
          </div>
          <div class="bottom">{{ orderItem.delevery[0].prd[0].attributes }}</div>
        </div>
      </div>
      <div class="item_good more" v-if="orderItem.delevery[0].prd.length > 1">
        <div class="top_more_out">
          <div class="top_more_item">
            <div class="more_item" v-for="(item, index) in orderItem.delevery[0].prd" :key="index">
              <div class="more_img">
                <img width="70px" height="70px" :src="item.productPic.split('|*|')[0].replace('http:', 'https:')" />
              </div>
              <p class="name">{{ item.productName }}</p>
              <p class="number">共{{ item.productNum }}件</p>
            </div>
          </div>
        </div>
      </div>
      <div class="total_bottom">
        <div class="date">{{ orderItem.buyerPayTime }}</div>
        <div class="all_price">
          共{{ orderItem.itemNum }}件<span>实收¥{{ orderItem.orderAmount }}</span>
        </div>
      </div>
    </div>
    <div class="customer_box" >
      <div class="title">顾客自提</div>
      <div class="text_box">
        <i class="left_icon user"></i>
        <div class="text">
          <div class="name">
            <p>联系人：{{ orderItem.buyerName }}</p>
          </div>
        </div>
      </div>
      <div class="text_box">
        <i class="left_icon site"></i>
        <div class="text">
          <div class="name" @click.stop="toPhone(orderItem.transUsrPhone)">
            <p>手机号：{{ orderItem.transUsrPhone }}</p>
            <i class="phone"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["orderItem"],
  data() {
    return {
    };
  },
  methods: {
    // 电话通知
    toPhone(phone) {
      console.log("phone===", phone);
      // Android
      if (navigator.userAgent.indexOf("Android") > -1) {
        window.location.href = `tel:${phone}`;
      }
      // IOS
      else {
        let dataString = {
          urlScheme: `tel:${phone}`,
        };
        window.dsBridge.call("generalAction", {
          type: "8",
          ios_action: JSON.stringify(dataString),
        });
      }
    },
    
  },
};
</script>

<style scoped lang="scss">
.item {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  .copy_icon {
    width: 32px;
    height: 15px;
    border-radius: 2px;
    border: 1px solid #999999;
    color: #333;
    font-size: 11px;
    text-align: center;
    line-height: 16px;
    display: inline-block;
    margin-left: 6px;
  }
  .top_title {
    height: 40px;
    padding: 6px 0 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    &.no_union_id {
      height: 46px;
    }
    .left_side {
      overflow: hidden;
      flex: 1;
      margin-left: 20px;
      .order_text {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        p {
          color: #333;
          font-weight: bold;
          font-size: 14px;
        }
      }
    }
    .right_tip {
      width: 64px;
      height: 27px;
      background: #fef0e5;
      border-radius: 14px 0px 0px 14px;
      line-height: 27px;
      text-align: center;
      color: #fe7003;
      font-size: 12px;
      &.done {
        background: #f6f6f7;
        color: #999;
      }
    }
  }
  .item_box {
    padding: 12px;
    .item_good {
      &.single {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .left_img {
          width: 70px;
          height: 70px;
          margin-right: 8px;
          img {
            width: 70px;
            height: 70px;
            border-radius: 4px;
          }
        }
        .right_side {
          flex: 1;
          .top {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            h2 {
              font-weight: 400;
              color: #333;
              font-size: 13px;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              width: 80%;
            }
            .price {
              font-weight: bold;
              color: #333;
              font-size: 12px;
            }
          }
          .bottom {
            color: #999;
            font-size: 12px;
            margin-top: 4px;
          }
        }
      }
      &.more {
        position: relative;
        .top_more_out {
          overflow-x: scroll;
          scrollbar-width: none;
          white-space: nowrap;
          &::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
          }
          .top_more_item {
            min-width: 100%;
            min-height: 116px;
            display: inline-flex;
            .more_item {
              width: 70px;
              margin-right: 8px;
              &:after {
                content: "";
                width: 18px;
                height: 100%;
                background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0.1) 100%);
                right: 0;
                top: 0;
                position: absolute;
              }
              &:last-child {
                margin-right: 0;
              }
              .more_img {
                width: 70px;
                height: 70px;
                img {
                  width: 70px;
                  height: 70px;
                  display: block;
                  border-radius: 4px;
                }
              }
              .name {
                font-size: 12px;
                color: #333;
                width: 70px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin: 4px 0;
              }
              .number {
                color: #666;
                font-size: 12px;
                text-align: center;
              }
            }
          }
        }
      }
    }
    .total_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
      .date {
        color: #999;
        font-size: 12px;
      }
      .all_price {
        color: #999;
        font-size: 13px;
        span {
          font-weight: bold;
          font-size: 14px;
          color: #333;
          margin-left: 6px;
        }
      }
    }
  }
  .customer_box {
    background: #f9f9f8;
    border-radius: 4px;
    margin: 0 10px 12px 10px;
    padding: 10px 16px 10px 10px;
    box-sizing: border-box;
    .title {
      font-weight: bold;
      color: #333;
      font-size: 13px;
    }
    .text_box {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 10px;
      .left_icon {
        width: 16px;
        height: 16px;
        &.user {
          background: url("../../../../assets/img/icon_6.png") no-repeat;
          background-size: 100% 100%;
        }
        &.site {
          background: url("../../../../assets/img/icon_3.png") no-repeat;
          background-size: 100% 100%;
        }
        &.logistics {
          background: url("../../../../assets/img/icon_4.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .text {
        margin-left: 10px;
        flex: 1;
        .name {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            color: #333;
            font-size: 13px;
            margin-right: 6px;
            margin-bottom: 2px;
          }
          .phone {
            width: 16px;
            height: 16px;
            background: url("../../../../assets/img/icon_5.png") no-repeat;
            background-size: 100% 100%;
            margin-left: 2px;
          }
        }
        .address {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            font-size: 13px;
            color: #999;
            margin-right: 6px;
            line-height: 22px;
          }
        }
        .time {
          color: #666;
          font-size: 12px;
        }
      }
    }
  }

}
</style>
